import React from 'react'
import { Select as AntSelect } from 'antd'
import {
  SelectProps as AntSelectProps,
  OptionProps as AntOptionProps
} from 'antd/lib/select'
import { Tag } from '../../atoms'

import styles from './_.module.css'

const { OptGroup } = AntSelect

type OptionProps = AntOptionProps
export interface SelectDropdownGroupProps extends AntSelectProps<string> {
  optionsList?: {
    normal: { value: string; title: string }[]
    advance: { value: string; title: string }[]
    sme: { value: string; title: string }[]
  }
}

export const CustomSelectDropdown: React.FC<SelectDropdownGroupProps> = ({
  bordered,
  className,
  defaultValue,
  disabled,
  children,
  maxTagCount,
  onBlur,
  onChange,
  placeholder,
  optionFilterProp,
  options,
  size,
  value,
  optionsList
}) => {
  const tagRender = (props: any) => {
    const { label, closable, onClose } = props

    // if the tag is closable means that it is the maxCount placeholder
    if (!closable) {
      return <span className={styles.maxPlaceholder}>{label}</span>
    }

    return (
      <Tag className={styles.selectTag} closable={closable} onClose={onClose}>
        <span className={styles.selectTagLabel}>{label}</span>
      </Tag>
    )
  }
  return (
    <div>
      <AntSelect
        className={className}
        bordered={bordered}
        defaultValue={defaultValue}
        disabled={disabled}
        mode="tags"
        onBlur={onBlur}
        options={options}
        optionFilterProp={optionFilterProp}
        placeholder={placeholder}
        optionLabelProp="label"
        size={size}
        maxTagCount={maxTagCount}
        tagRender={tagRender}
        maxTagPlaceholder={item => {
          return `+${item.length}`
        }}
        value={value}
        onChange={onChange}
      >
        <OptGroup label="Beginner">
          {optionsList?.normal?.map(optionList => (
            <GetOption
              value={optionList.value}
              label={optionList.title}
              key={optionList.value}
            >
              {optionList.title}
            </GetOption>
          ))}
        </OptGroup>
        <OptGroup label="Advanced">
          {optionsList?.advance?.map(option => (
            <GetOption
              value={option.value}
              label={option.title}
              key={option.value}
            >
              {option.title}
            </GetOption>
          ))}
        </OptGroup>
        <OptGroup label="SME">
          {optionsList?.sme?.map(option => (
            <GetOption
              value={option.value}
              label={option.title}
              key={option.value}
            >
              {option.title}
            </GetOption>
          ))}
        </OptGroup>
      </AntSelect>
    </div>
  )
}

export const GetOption: React.FC<OptionProps> = ({
  children,
  label,
  value
}) => (
  <AntSelect.Option label={label} value={value}>
    {children}
  </AntSelect.Option>
)
